var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustrationRunningHero(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 560,
    height: 321,
    viewBox: "0 0 560 321",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "slbb8q154a",
    d: "M0 0h91.493v39.807H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "2gv3529vrc",
    d: "M.344.349h.688v.697H.344z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "bax3bmz1ve"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "wspcltr5ag"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "oe7n7ekkri"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "wyvj1t0wwk"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "f587efvmtm"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "31enpgtkno"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "8bjabggvyq"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "mrnrhlddws"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "hopx8469mu"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "2w1r27t56w"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "6abtffxcny"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "6v9x031o8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "cnu1gj8z6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "u4nntqmgyE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "rdwrjugohG"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "72grixu57I"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "p8fzezru7K"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "05zqfdxj2M"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "1s6p75imyO"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "rc1kwuznbQ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "4knz4327lS"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "v4m5ifclxU"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "ztofq640eW"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "4md0pzjxoY"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "fkgo51509aa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "oupwgeku7ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "h2h9xrk9yae"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "crzg2gxv3ag"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "lc61957i2ai"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "g2gdr5s78ak"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "j6s6wyl82am"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "plbvfpi7oao"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "1s2feg9oraq"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "uzad3jbltas"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "f70rmp3biau"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "aoilvhdyjaw"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "2qvnwa0wmay"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "yfj3746lsaA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "xf1fuvnl1aC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "vm4spga0naE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "rd0u74nrkaG"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "k8i937ggfaI"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "gqvz85lqwaK"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "c9dcsza7haM"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "sqtore9kkaO"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "46ww6kg3faQ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "jtb6ij8hqaS"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "sr9ai1t3daU"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "0pdw0947kaW"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "n71tx5qamaY"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "nuuvsmgwwba"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "omdcqjnisbc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "tjocu5928be"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "a6d9u3ntibg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "ipdw2x1fibi"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "lhbn91tsrbk"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "cpzd900gnbm"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "txnlw3iz3bo"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "wgm35zmvnbq"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "klpespd8qbs"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "2dx8j75wtbu"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "gdv65owhjbw"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "3emfhrp55by"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "eqigk8vqcbA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "bjqxs7bwvbC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "q0j3tjyetbE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "qmi275wkbbG"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "f979tfix3bI"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "2g9lbnguhbK"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "omyzebifpbM"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "sx8xchcgsbO"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "wioa3fkdabQ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "g1haismpwbS"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "4o7bmtbyybU"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "nq57sirywbW"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "5owyk91sjbY"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "ad455gn3cca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "q15yx4uvtcc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "vtrkokkwyce"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "g0tnrp3tycg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "1vosj8djdci"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "7b5rsxdqdck"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "osdj01q64cm"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "wsxo44h9vco"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "xgyy7zq3zcq"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "dutl1vx5rcs"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "v4go6b5becu"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "j4v5hd21ocw"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "06tfq0wlhcy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "g4e5b4fifcA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "rhza351dxcC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "cd9z9zlkncE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "pryqlehbxcG"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "jatcr0tk0cI"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "adtjmzqe3cK"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "8e4xbxed2cM"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "70tz9wrq0cO"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "zuprjb7l9cQ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "w7kbhztpdcS"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "u5mly40kscU"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "51qeoievxcW"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "icd69pxlacY"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 52.448 174.156 130.98 10.228-9.154S30.462 3.257 25.015 0",
    id: "0eetkjoclda"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "dmb55y7a4dc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "vw9x16ccade"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "e6kagjunkdg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "cgazlwztidi"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "u9jj5i5rvdk"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "6ijzv60o0dm"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "qsm73tz7xdo"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "vswpp1s7wdq"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "fjwahn5ovds"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "9af3y73m8du"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "ifdhaib38dw"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "2zmuemdsqdy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "sj1g1a7codA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "8hegrifd1dC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "yuf32rdjfdE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "a69murlxhdG"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "n8ez3do8sdI"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "orlro10jddK"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "s5hecy1a0dM"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "9ky4smki9dO"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "pihl6vn92dQ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "wszzub1k9dS"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "326axpiqbdU"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "uewns1z2idW"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "avyx4wcypdY"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "iz89zbdyrea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "jot00uchfec"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "vx6phat91ee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "araoojewgeg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "2p6xpeqloei"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "8ojdpbwp1ek"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "56el8fiq6em"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "9lw329zo2eo"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "q4gna95npeq"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "6xsirquu2es"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "fpt5vgxjreu"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "itxy55j4oew"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "2k92jgt2key"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "v9vjce7tyeA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "5m1750pi0eC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "wcfslfidkeE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "kfakvmpcxeG"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "ekuje5tvqeI"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "lawd3mm4keK"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "854czl40xeM"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "nuoga8c16eO"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "g30207u47eQ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "x2vm7kre7eS"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "aucnc53kceU"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "12u97pzc8eW"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "wlyckbzwleY"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "k06a5c026fa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "hqyoiucfufc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "i4jfp1m2sfe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "dsdfsgyl9fg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "tm5r33btzfi"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "f5taoiop0fk"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "ljdrgxs3ufm"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "rjhrs45c1fo"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "blgylou41fq"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "7l9740rv7fs"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "m5d9s00nhfu"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "ro1wlfkyrfw"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "3he4ufcvrfy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "nsrzt6inofA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "1kdkdoum7fC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "8wdtfqwp5fE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "53cgsup5gfG"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "b9hu6owqsfI"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "wbrbdp53ufK"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "9xe9muz33fM"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "5d21lucfjfO"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "hjcrfd263fQ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "ksl7ga83efS"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "nl6b2gmewfU"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "wnpitulexfW"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "6nfd6kzk5fY"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "qsnh6pbc4ga"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "h4am2bisigc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "m9kq2bxh8ge"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "lvt6glysogg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "gkhuyuruggi"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "0355389kggk"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "whw4mvj3fgm"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "hvfxo5cz4go"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "airzja64kgq"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "0oo5iapddgs"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "zq28lcrthgu"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "sorh31017gw"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "919lpdw62gy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "k553s5j2mgA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "lwusei3pbgC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "ix175xt0lgE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "hv7jaco02gG"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "gobwxxxc1gI"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "8vxyzw8ufgK"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "icfz9wd8tgM"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "y92cve781gO"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.728 94.681a5.171 5.171 0 0 1-4.426 2.512l-93.234-.092L0 113.267s93.408 17.933 115.456 12.907c0 0 34.918-10.737 78.481-115.033L142.608 0",
    id: "3w9e7risygQ"
  }), /*#__PURE__*/React.createElement("path", {
    id: "yr7sv9uf4gS",
    d: "M0 0h91.493v39.807H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FEFEFE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m347.807 131.067 22.054 5.647c4.199 3.014 8.131 5.182 11.794 6.5 1.056.154 2.783-.039.51-2.426-2.273-2.39-4.558-5.003-3.983-6.072.573-1.07 2.86-.385 3.44-2.064.388-1.117-3.38-1.74-11.301-1.868l-17.36-9.322-5.154 9.605zM264.958 107.05a3.826 3.826 0 0 0-4.325 2.378c-.777 1.991.19 4.24 2.16 5.024.213.086.43.15.646.194a3.826 3.826 0 0 0 4.325-2.378c.776-1.99-.193-4.24-2.162-5.025a4.038 4.038 0 0 0-.644-.193M261.339 129.551a3.826 3.826 0 0 0-4.325 2.378c-.777 1.991.19 4.24 2.162 5.025.212.085.428.149.643.193a3.827 3.827 0 0 0 4.326-2.378c.775-1.99-.192-4.24-2.162-5.024a3.946 3.946 0 0 0-.644-.194M254.154 150.633a3.824 3.824 0 0 0-4.325 2.378c-.776 1.991.19 4.24 2.16 5.024.213.084.428.15.645.194a3.829 3.829 0 0 0 4.326-2.378c.775-1.991-.193-4.24-2.161-5.024a3.691 3.691 0 0 0-.645-.194M301.24 15.296c0 1.976-1.127 3.578-2.516 3.578-1.39 0-2.516-1.602-2.516-3.578 0-1.974 1.126-3.576 2.516-3.576 1.39 0 2.515 1.602 2.515 3.576"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m350.225 131.067 22.054 5.647c4.199 3.014 8.13 5.182 11.793 6.5 1.057.154 2.784-.039.51-2.426-2.272-2.39-4.557-5.003-3.983-6.072.574-1.07 2.86-.385 3.44-2.064.389-1.117-3.38-1.74-11.3-1.868l-17.36-9.322-5.154 9.605zM388.767 117.296c7.917 3.732 15.165 4.962 16.184 2.747 1.022-2.213-4.568-7.033-12.486-10.765"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.89 113.315c3.94-.11 8.186.735 12.699 2.497 2.222.868 3.326 3.39 2.469 5.637a4.32 4.32 0 0 1-2.78 2.601c.85.687 1.707 1.369 2.571 2.047l-8.389 15.557c-31.707-17.769-61.64-31.431-74.357-59.014-4.268-9.259-1.363-39.938-1.325-51.145l10.42-3.793c12.982 30.45 31.06 59.91 58.692 85.613"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.895 21.448c-1.529-3.795-2.027-7.98-.403-11.93 4.682-11.384 20.028-3.333 21.228 3.62 1.2 6.951-4.122 21.75-8.541 21.423-1.764-.131-4.882-2.33-7.698-5.649l-2.982 16.414-13.049-4.42 11.445-19.458z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.97 119.643c26.812 14.271 40.908 1.438 58.213 4.734 7.044-25.513 17.143-65.996 20.017-82.91-.542 3.192-3.432-6.992-9.658-10.598-28.057 19.38-48.042 46.478-68.572 88.774"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.988 36.103s2.619 7.2 7.847 7.492c0 0 4.613 11.695-11.716 67.253l-25.419-4.552 20.435-60.97 8.853-9.223zM235.216 125.69c-19.97 37.766-49.62 84.576-51.312 85.75-1.13.784-47.569.523-108.351-.776l-.952 10.507c68.515 13.2 120.907 17.785 126.208 13.755 7.955-6.044 48.297-59.993 71.515-94.69l-37.108-14.545z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.425 210.456c-1.861-1.066-3.282-1.678-4.265-1.835-1.193-.191-2.97-.269-5.323-.234l-5.917 37.77c3.858.924 5.28-.209 5.868-2.282.588-2.074.69-2.38 1.115-3.745l10.492-16.315a.682.682 0 0 0-.196-.938l-.017-.01-2.532-1.562c-.595-2.102-.798-3.765-.606-4.99.155-.993.768-2.302 1.836-3.929a1.363 1.363 0 0 0-.374-1.879l-.081-.051zM86.456 209.08l-1.076 16.18s94.01 17.947 116.201 12.916c0 0 35.144-10.745 78.988-115.123l-51.66-11.15-44.164 94.756a5.214 5.214 0 0 1-4.455 2.514l-93.834-.093z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "m215.91 154.641 113.088 80.862 91.166 70.211 8.791-3.658-169.715-165.44z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.804 306.814c.084 1.96.306 3.36.663 4.2.434 1.02 1.24 2.44 2.416 4.254 1.189-.501 11.87-5.021 32.046-13.56-1.217-2.91-2.22-4.154-4.11-3.614-1.887.54-2.688.753-3.95 1.08l-17.712-.318a.616.616 0 0 0-.628.605v.016l.029 2.721c-1.333 1.476-2.517 2.433-3.557 2.872-.844.357-2.153.51-3.928.46a1.23 1.23 0 0 0-1.27 1.196v.088zM412.484 304.404l10.278-9.157S268.076 124.172 262.604 120.914l-25.139 52.466 175.02 131.024zM180.485 94.658l8.805 5.434c-19.607 17.45-30.05 26.646-31.327 27.588-2.876 2.124-3.1 7.896-3.486 10.835-4.287-.555-.512-5.894-5.966-6.52-4.98-.57-9.928.887-12.713-4.602-.342-.675-.16-2.318 1.908-2.423 5.156-.264 13.057-1.41 14.642-2.409 2.162-1.36 11.541-10.662 28.137-27.903M306.257 33.352s-5.204 3.71-6.27 13.271c-1.41.018-2.525-5.022-2.525-5.022l3.24-10.038L304 28.621l2.258 4.73z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(228.025)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "vq7d36d4ab",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#slbb8q154a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.862 17.127s5.037-4.98 14.286-2.667c0 0 4.24-4.765-2.335-8.802C81.24 1.619 76.38.408 67.931 5.08c-6.908 3.82-11.26 3.082-16.578.677-5.318-2.403-8.073-5.234-12.47-4.197-4.398 1.038-7.14 5.177-11.889 3.387C22.246 3.157 20.25-1.9 11.917.753 3.584 3.407-6.717 16.56 5.899 29.83c12.615 13.267 31.487 10.267 42.94 7.96 11.453-2.307 22.194-4.964 23.593-8.777 1.399-3.814-2.18-8.09 3.43-11.885",
    fill: "#FEFEFE",
    mask: "url(#vq7d36d4ab)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M180.18 63.191c13.826-7.836 30.581-10.508 48.868-14.32l-11.803 7.042-29.175 9.697s-7.855-.362-7.89-2.419M304.84 18.532c0 1.962-1.134 3.552-2.532 3.552-1.399 0-2.533-1.59-2.533-3.552 0-1.96 1.134-3.55 2.533-3.55 1.398 0 2.532 1.59 2.532 3.55M318.14 24.331l.642 6.596a.64.64 0 0 1-.844.668l-3.667-1.243 3.869-6.021z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m224.061 101.904 3.964.447s-34.667 36.419-42.683 34.01c-8.015-2.409-41.074-40.608-38.585-48.957 2.489-8.346 36.99-26.104 36.99-26.104l40.314 40.604z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.65 124.392a4.311 4.311 0 0 1 .224-4.11l1.512-2.459a4.348 4.348 0 0 1 4.802-1.926 73.308 73.308 0 0 0 2.356-3.694c6.227-10.467 7.464-22.642 11.862-33.35-19.28 6.608-40.596 22.715-63.95 48.326l-14.985-11.627a330.475 330.475 0 0 1 4.814-6.307c-1.518-1.876-1.798-7.851.183-8.054a21.306 21.306 0 0 1 6.128.259c33.976-40.556 72.869-64.7 116.683-72.432l4.847 1.903 4.96 3.77c-18.655 38.43-25.645 114.028-72.48 178.12-12.796-2-22.344-12.262-36.715-20.137-18.176-9.96-25.307-32.296-49.23-32.182 13.13-29.202 55.878-9.079 78.99-36.1",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.809 109.613a3.861 3.861 0 0 0-4.354 2.36 3.84 3.84 0 0 0 2.175 4.987 3.861 3.861 0 0 0 5.004-2.168 3.843 3.843 0 0 0-2.825-5.18M250.203 130.628a3.862 3.862 0 0 0-4.353 2.36 3.841 3.841 0 0 0 2.824 5.18 3.863 3.863 0 0 0 4.354-2.36 3.842 3.842 0 0 0-2.176-4.988 4.014 4.014 0 0 0-.649-.192M242.088 152.876a3.86 3.86 0 0 0-4.354 2.36 3.84 3.84 0 0 0 2.175 4.987 3.864 3.864 0 0 0 5.004-2.168 3.841 3.841 0 0 0-2.176-4.986 3.755 3.755 0 0 0-.65-.193M276.864 29.018s-4.643 28.135-20.186 46.158c-14.468 16.78-40.386 26.138-40.386 26.138l4.443 3.905s20.099-3.601 43.01-30.661c16.84-19.886 19.43-45.659 19.43-45.659l-6.31.119zM426.301 310.394l6.451 4.153 16.266-7.157-2.936-5.497-19.78 8.5zm-1.148.492v.002l1.148-.494-1.148.492zm-8.617 3.705 3.577 5.454 8.43-3.744-3.39-5.413-8.617 3.703zM318.197 24.827l-1.574-.882a2.62 2.62 0 0 1-1.006-3.598l1.03-1.786a.825.825 0 0 1 1.116-.304l3.188 1.787a.094.094 0 0 1 .037.128l-2.66 4.619a.096.096 0 0 1-.131.036",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FEFEFE",
    strokeWidth: 0.903,
    strokeLinecap: "round",
    d: "m316.223 19.107-11.464-2.866"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "m70.696 211.134-5.637 36.304-5.827-1.474 2.697-20.416 7.064-3.447.2-1.29-6.483.041 1.369-9.534zM394.18 133.064s5.656 9.31-6.29 9.31l6.29-9.31zM390.363 112.995c1.978.73 3.79.746 4.045.037.254-.71-1.144-1.877-3.122-2.608-1.979-.73-3.79-.746-4.045-.036-.255.71 1.143 1.878 3.122 2.607"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 319.606)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "u8mnb6jzjd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#2gv3529vrc"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M38.214 27.952v41.79l70.697-27.715L97.128 9.554zM183.67 43.946l-21.26 37.907 55.171 32.79 21.258-37.906z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F2EE",
    d: "M113.25 19.107 75.473 46.083l54.142 30.346 31.84-26.353zM0 69.488l6.795 35.601L62.098 69.64l-15.25-25.694z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m352.496 131.47 22.088 5.621c4.205 3.001 8.143 5.16 11.811 6.472 1.058.154 2.788-.038.511-2.416-2.276-2.379-4.565-4.981-3.99-6.045.575-1.066 2.865-.383 3.446-2.055.39-1.113-3.385-1.733-11.318-1.86l-17.387-9.281-5.16 9.563zM269.52 107.556a3.836 3.836 0 0 0-4.332 2.368 3.861 3.861 0 0 0 2.81 5.195c1.79.366 3.639-.6 4.332-2.368a3.865 3.865 0 0 0-2.81-5.195M265.895 129.96c-1.79-.366-3.64.6-4.331 2.367a3.863 3.863 0 0 0 2.809 5.195c1.79.366 3.639-.599 4.333-2.367.776-1.982-.193-4.222-2.165-5.002a3.969 3.969 0 0 0-.646-.194M258.7 150.95a3.834 3.834 0 0 0-4.332 2.367 3.861 3.861 0 0 0 2.81 5.195c1.79.366 3.638-.6 4.332-2.367a3.864 3.864 0 0 0-2.81-5.195M305.857 16.202c0 1.967-1.128 3.562-2.52 3.562-1.391 0-2.52-1.595-2.52-3.562 0-1.966 1.129-3.56 2.52-3.56 1.392 0 2.52 1.594 2.52 3.56",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m354.918 131.47 22.087 5.621c4.205 3.001 8.142 5.16 11.812 6.472 1.058.154 2.787-.038.51-2.416-2.275-2.379-4.564-4.981-3.989-6.045.575-1.066 2.865-.383 3.446-2.055.389-1.113-3.385-1.733-11.319-1.86l-17.386-9.281-5.161 9.563z",
    fill: "#FE912A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.012 107.037c-.997 2.15-5.264 33.789-5.264 33.789s5.296 6.22 13.441 6.3l20.54-26.633-28.717-13.456z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.518 117.758c7.93 3.715 15.189 4.94 16.21 2.735 1.023-2.203-4.575-7.002-12.506-10.719-7.93-3.715-15.187-4.941-16.209-2.738-1.023 2.205 4.576 7.007 12.505 10.722",
    fill: "#8D8785"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.812 95.763c-.514-4.124-.967-9.185-4.356-12.062-1.893-1.61-7.688-3.336-8.064.658-.315 3.318 5.033 5.093 7.214 6.271 2.294 1.24 3.152 2.532 3.971 5.02.186.04.374.076.56.113",
    fill: "#FE912A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.583 113.794c3.947-.11 8.199.732 12.719 2.486 2.225.865 3.331 3.376 2.472 5.613a4.316 4.316 0 0 1-2.783 2.59c.85.683 1.71 1.362 2.575 2.037l-8.402 15.49c-31.756-17.692-61.735-31.295-74.471-58.758-4.275-9.218-1.366-39.764-1.327-50.922l10.436-3.776c13.002 30.317 31.107 59.649 58.781 85.24",
    fill: "#AAE2BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.506 22.327c-1.532-3.78-2.03-7.946-.404-11.88 4.689-11.333 20.059-3.317 21.26 3.606 1.203 6.92-4.127 21.656-8.554 21.33-1.766-.131-4.889-2.32-7.71-5.625l-2.986 16.343-13.068-4.4 11.462-19.374z",
    fill: "#FE912A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.464 120.094c26.853 14.21 40.972 1.432 58.303 4.714 7.054-25.402 17.17-65.709 20.047-82.55-.542 3.178-3.437-6.96-9.672-10.552-28.1 19.297-48.117 46.277-68.678 88.388",
    fill: "#FE912A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.59 36.918s2.622 7.168 7.86 7.46c0 0 4.62 11.643-11.736 66.96l-25.457-4.532 20.467-60.704 8.866-9.184z",
    fill: "#DFE15C"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FE912A",
    d: "m216.866 154.641 113.087 80.862 91.166 70.211 8.792-3.658-169.716-165.44z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M236.806 128.53c-20.06 37.476-49.842 83.927-51.542 85.093-1.135.777-47.78.518-108.835-.77l-.956 10.425c68.821 13.098 121.447 17.649 126.772 13.65 7.99-5.998 48.513-59.533 71.835-93.963l-37.274-14.435z",
    fill: "#FE912A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m412.967 304.759 10.256-9.155S268.867 124.587 263.407 121.33l-25.085 52.448 174.645 130.98z",
    fill: "#22244E"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "36jnqyxybf",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bax3bmz1ve"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#36jnqyxybf)",
    d: "m-15.108-28.539.164 10.267"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "82hed2mqjh",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#wspcltr5ag"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#82hed2mqjh)",
    d: "m45.745 23.1.164 10.267"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "jo80urezvj",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#oe7n7ekkri"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#jo80urezvj)",
    d: "m-14.282 31.358 10.093-1.798"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mknxg1vtbl",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#wyvj1t0wwk"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#mknxg1vtbl)",
    d: "m46.571 82.997 10.093-1.799"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "l0u4kaenbn",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f587efvmtm"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#l0u4kaenbn)",
    d: "m-16.705 45.646-.164-10.266"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ajkbz86l0p",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#31enpgtkno"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#ajkbz86l0p)",
    d: "m-36.923 11.181.164 10.266"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ax08wzu4mr",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#8bjabggvyq"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#ax08wzu4mr)",
    d: "m23.93 62.82.164 10.267"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "av4mulcfit",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mrnrhlddws"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#av4mulcfit)",
    d: "m70.023 115.682.163 10.266"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "p7acwstx2v",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hopx8469mu"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#p7acwstx2v)",
    d: "M20.488 2.333 30.581.535"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "rvbfnjqcdx",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#2w1r27t56w"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#rvbfnjqcdx)",
    d: "m81.341 53.972 10.093-1.798"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "vhfdejv48z",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#6abtffxcny"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#vhfdejv48z)",
    d: "m1.799 53.281 10.093-1.798"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "nsgbr9aypB",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#6v9x031o8A"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#nsgbr9aypB)",
    d: "m-26.3 6.675 4.956 8.988"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "az3uoq9doD",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cnu1gj8z6C"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#az3uoq9doD)",
    d: "m34.553 58.314 4.956 8.988"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "0haieazefF",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u4nntqmgyE"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#0haieazefF)",
    d: "m18.097 13.637 9.756 3.157"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "52e0kzuwcH",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rdwrjugohG"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#52e0kzuwcH)",
    d: "m78.95 65.275 9.757 3.158"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "33zz429itJ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#72grixu57I"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#33zz429itJ)",
    d: "m-.591 64.584 9.756 3.158"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ngq3ymiyrL",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p8fzezru7K"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#ngq3ymiyrL)",
    d: "m-12.022-.05.163 10.267"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "xb085xlkaN",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#05zqfdxj2M"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#xb085xlkaN)",
    d: "m48.831 51.589.163 10.266"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "9on9ydyqkP",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#1s6p75imyO"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#9on9ydyqkP)",
    d: "m14.231 28.956 10.093-1.798"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "yuj62ocukR",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rc1kwuznbQ"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#yuj62ocukR)",
    d: "m75.084 80.595 10.093-1.799"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "lyj2srhmeT",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#4knz4327lS"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#lyj2srhmeT)",
    d: "m65.819 37.894 10.092-1.799"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ylyym4mnpV",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#v4m5ifclxU"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#ylyym4mnpV)",
    d: "m-12.24-6.45-8.686-5.454"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "e923u5qwqX",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ztofq640eW"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#e923u5qwqX)",
    d: "m48.613 45.19-8.686-5.455"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "7vdrimn02Z",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#4md0pzjxoY"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#7vdrimn02Z)",
    d: "m53.424 97.565-8.686-5.455"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ruyis0bhiab",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fkgo51509aa"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#ruyis0bhiab)",
    d: "M7.916 29.963.912 22.465"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "e654pcm3dad",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#oupwgeku7ac"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#e654pcm3dad)",
    d: "m61.707 32.155-7.005-7.498"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ck2vo6wriaf",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h2h9xrk9yae"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#ck2vo6wriaf)",
    d: "m68.769 81.602-7.004-7.498"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "t5xj2oqb0ah",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#crzg2gxv3ag"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#t5xj2oqb0ah)",
    d: "m-35.123 2.844-8.686-5.454"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "wqrj66abjaj",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lc61957i2ai"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#wqrj66abjaj)",
    d: "m25.73 54.484-8.686-5.455"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "47ywfweb5al",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g2gdr5s78ak"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#47ywfweb5al)",
    d: "m6.971.348 7.486-7.015"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "qsyxk18jnan",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j6s6wyl82am"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#qsyxk18jnan)",
    d: "m67.824 51.987 7.486-7.015"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "hede2nq8hap",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#plbvfpi7oao"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#hede2nq8hap)",
    d: "m-11.718 51.295 7.487-7.015"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "kck06fa68ar",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#1s2feg9oraq"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#kck06fa68ar)",
    d: "m-25.52-17.082-6.439-7.989"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "lt9dem6i3at",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#uzad3jbltas"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#lt9dem6i3at)",
    d: "m35.333 34.556-6.439-7.989"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "7db5kahrlav",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f70rmp3biau"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#7db5kahrlav)",
    d: "m-6.825 21.871-9.06-4.806"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "l6tomhclxax",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aoilvhdyjaw"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#l6tomhclxax)",
    d: "m55.814 70.575-9.06-4.806"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "bsyly1ym7az",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#2qvnwa0wmay"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#bsyly1ym7az)",
    d: "m40.103 79.901-9.06-4.806"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ny5z29ivcaB",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#yfj3746lsaA"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#ny5z29ivcaB)",
    d: "m.573-5.797-6.44-7.989"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "dcg7pgz0eaD",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#xf1fuvnl1aC"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#dcg7pgz0eaD)",
    d: "m61.425 45.841-6.439-7.989"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "xbsyupsgiaF",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#vm4spga0naE"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#xbsyupsgiaF)",
    d: "m11 42.435-9.059-4.807"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "95ojzqlhqaH",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rd0u74nrkaG"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#95ojzqlhqaH)",
    d: "m71.854 94.074-9.06-4.807"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "6jb8c5jt6aJ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k8i937ggfaI"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#6jb8c5jt6aJ)",
    d: "m-32.386 22.905 6.439 7.989"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "2svwq5rb6aL",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gqvz85lqwaK"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#2svwq5rb6aL)",
    d: "m-20.374-1.107-10.251.164"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "8vf9t3gxlaN",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c9dcsza7haM"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#8vf9t3gxlaN)",
    d: "m40.479 50.532-10.251.164"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "4qjq24wd6aP",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#sqtore9kkaO"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#4qjq24wd6aP)",
    d: "m40.812 86.595-10.251.164"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "on5w3v503aR",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#46ww6kg3faQ"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#on5w3v503aR)",
    d: "m21.371 77.648-10.251.164"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "fecgkbsz9aT",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#jtb6ij8hqaS"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#fecgkbsz9aT)",
    d: "M11.601 20.947 9.806 10.839"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ponaln23caV",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#sr9ai1t3daU"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#ponaln23caV)",
    d: "M5.804-12.704 4.009-22.812"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "x2a8535ifaX",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#0pdw0947kaW"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#x2a8535ifaX)",
    d: "m72.454 72.586-1.795-10.109"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "wszdb9mkpaZ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n71tx5qamaY"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#wszdb9mkpaZ)",
    d: "m-32.728-11.305-10.251.163"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ibqrpum87bb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nuuvsmgwwba"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#ibqrpum87bb)",
    d: "M-6.697 6.593 3.396 4.794"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "crtt1by52bd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#omdcqjnisbc"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#crtt1by52bd)",
    d: "m54.156 58.232 10.093-1.798"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "4gds5k449bf",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tjocu5928be"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#4gds5k449bf)",
    d: "m32.852 18.264 10.093-1.798"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "2owe3f05dbh",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a6d9u3ntibg"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#2owe3f05dbh)",
    d: "m98.123 64.942.163 10.266"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "bkcaxjlmkbj",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ipdw2x1fibi"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#bkcaxjlmkbj)",
    d: "m158.976 116.581.163 10.266"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "s23530jfnbl",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lhbn91tsrbk"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#s23530jfnbl)",
    d: "m98.949 124.839 10.093-1.798"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "t5ltwjnvnbn",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cpzd900gnbm"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#t5ltwjnvnbn)",
    d: "m159.802 176.478 10.093-1.798"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "wpm4jj9e2bp",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#txnlw3iz3bo"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#wpm4jj9e2bp)",
    d: "m96.526 139.127-.164-10.266"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f4sxu1zoubr",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#wgm35zmvnbq"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#f4sxu1zoubr)",
    d: "m76.308 104.662.164 10.266"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "6desi2xszbt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#klpespd8qbs"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#6desi2xszbt)",
    d: "m137.161 156.301.164 10.266"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "s6s6j1huibv",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#2dx8j75wtbu"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#s6s6j1huibv)",
    d: "m133.719 95.814 10.093-1.798"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "6i1t163bcbx",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gdv65owhjbw"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#6i1t163bcbx)",
    d: "m194.572 147.453 10.092-1.799"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "1ka6in89cbz",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#3emfhrp55by"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#1ka6in89cbz)",
    d: "m115.03 146.762 10.093-1.799"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "edtvxj7cwbB",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#eqigk8vqcbA"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#edtvxj7cwbB)",
    d: "m86.931 100.156 4.956 8.988"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "qj092fwxibD",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bjqxs7bwvbC"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#qj092fwxibD)",
    d: "m147.784 151.795 4.956 8.988"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "n0ata4i17bF",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#q0j3tjyetbE"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#n0ata4i17bF)",
    d: "m131.328 107.117 9.757 3.158"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "zd8owucenbH",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#qmi275wkbbG"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#zd8owucenbH)",
    d: "m192.181 158.756 9.757 3.158"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "zypee0k3ebJ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f979tfix3bI"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#zypee0k3ebJ)",
    d: "m112.64 158.065 9.756 3.158"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "talx00l77bL",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#2g9lbnguhbK"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#talx00l77bL)",
    d: "m101.209 93.431.163 10.267"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "rdaekn2uibN",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#omyzebifpbM"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#rdaekn2uibN)",
    d: "m162.062 145.07.163 10.266"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "9qj0fnfy1bP",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#sx8xchcgsbO"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#9qj0fnfy1bP)",
    d: "m127.462 122.437 10.093-1.799"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "l4o0q9pqjbR",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#wioa3fkdabQ"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#l4o0q9pqjbR)",
    d: "m188.315 174.076 10.093-1.798"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "j2u2n7rgubT",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g1haismpwbS"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#j2u2n7rgubT)",
    d: "m179.05 131.374 10.093-1.798"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "uxfwuip6dbV",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#4o7bmtbyybU"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#uxfwuip6dbV)",
    d: "m100.991 87.031-8.686-5.454"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "nnrzfrz0cbX",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nq57sirywbW"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#nnrzfrz0cbX)",
    d: "m161.844 138.67-8.686-5.455"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "nzfr57g94bZ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#5owyk91sjbY"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#nzfr57g94bZ)",
    d: "m166.655 191.045-8.686-5.455"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "r9kq82v3pcb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ad455gn3cca"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#r9kq82v3pcb)",
    d: "m121.148 123.444-7.005-7.498"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "6rv5pzs3ncd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#q15yx4uvtcc"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#6rv5pzs3ncd)",
    d: "m174.937 125.636-7.004-7.498"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mfmu7b5jocf",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#vtrkokkwyce"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#mfmu7b5jocf)",
    d: "m182.001 175.083-7.005-7.498"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "jdv2606l5ch",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g0tnrp3tycg"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#jdv2606l5ch)",
    d: "m138.961 147.964-8.686-5.454"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "cqxnm0r22cj",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#1vosj8djdci"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#cqxnm0r22cj)",
    d: "m120.201 93.829 7.487-7.015"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "frng7nisdcl",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#7b5rsxdqdck"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#frng7nisdcl)",
    d: "m181.054 145.468 7.487-7.015"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "tp1no4daacn",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#osdj01q64cm"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#tp1no4daacn)",
    d: "m101.513 144.776 7.487-7.014"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "foxxgjoybcp",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#wsxo44h9vco"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#foxxgjoybcp)",
    d: "m148.564 128.038-6.439-7.99"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "09dymezmucr",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#xgyy7zq3zcq"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#09dymezmucr)",
    d: "m106.406 115.352-9.06-4.806"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "fq6r0spe7ct",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dutl1vx5rcs"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#fq6r0spe7ct)",
    d: "m169.045 164.056-9.06-4.806"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "wp7mfmq2mcv",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#v4go6b5becu"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#wp7mfmq2mcv)",
    d: "m153.333 173.382-9.06-4.807"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "90fx9siyccx",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j4v5hd21ocw"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#90fx9siyccx)",
    d: "m113.803 87.683-6.439-7.989"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "usho8fo3ycz",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#06tfq0wlhcy"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#usho8fo3ycz)",
    d: "m174.656 139.322-6.439-7.989"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "pvfnj27jccB",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g4e5b4fifcA"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#pvfnj27jccB)",
    d: "m124.231 135.916-9.06-4.807"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "lb0dxtkrpcD",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rhza351dxcC"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#lb0dxtkrpcD)",
    d: "m67.422 109.21-9.059-4.806"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "6par3mb0rcF",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cd9z9zlkncE"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#6par3mb0rcF)",
    d: "m185.084 187.555-9.06-4.807"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ngjs5f5yrcH",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pryqlehbxcG"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#ngjs5f5yrcH)",
    d: "m80.845 116.386 6.439 7.989"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "tmnjctjf0cJ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#jatcr0tk0cI"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#tmnjctjf0cJ)",
    d: "m92.857 92.374-10.251.164"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "00ouxi5z1cL",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#adtjmzqe3cK"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#00ouxi5z1cL)",
    d: "m153.71 144.013-10.251.164"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "jau9t3mx3cN",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#8e4xbxed2cM"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#jau9t3mx3cN)",
    d: "m154.043 180.076-10.251.164"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "idg3aue6mcP",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#70tz9wrq0cO"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#idg3aue6mcP)",
    d: "m124.832 114.428-1.796-10.109"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "p90qwjduwcR",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#zuprjb7l9cQ"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#p90qwjduwcR)",
    d: "m119.036 80.777-1.796-10.108"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "glytagzv9cT",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#w7kbhztpdcS"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#glytagzv9cT)",
    d: "m185.685 166.067-1.795-10.108"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "uf9x37og8cV",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u5mly40kscU"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#uf9x37og8cV)",
    d: "m141.356 133.814-10.251.164"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ck5inhqgocX",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#51qeoievxcW"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#ck5inhqgocX)",
    d: "m106.534 100.074 10.093-1.799"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "0y1k4v7vncZ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#icd69pxlacY"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#0y1k4v7vncZ)",
    d: "m167.387 151.713 10.093-1.799"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.884 121.33)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "7n6ja2ru4db",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#0eetkjoclda"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#7n6ja2ru4db)",
    d: "m146.082 111.745 10.093-1.799"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#22244E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.471 210.422c-1.872-1.067-3.301-1.68-4.29-1.836-1.2-.192-2.986-.27-5.354-.235l-5.952 37.805c3.881.926 5.312-.208 5.902-2.283.592-2.076.694-2.383 1.122-3.749l10.554-16.33a.68.68 0 0 0-.198-.939l-.016-.01-2.547-1.564c-.599-2.104-.803-3.768-.61-4.995.156-.994.773-2.304 1.848-3.932a1.36 1.36 0 0 0-.377-1.88l-.082-.052zM87.532 209.045 86.45 225.24s94.563 17.964 116.884 12.929c0 0 35.35-10.756 79.452-115.232l-51.964-11.16-44.423 94.845a5.25 5.25 0 0 1-4.481 2.516l-94.386-.093z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c4kly8hdgdd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dmb55y7a4dc"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#c4kly8hdgdd)",
    d: "m225.553 55.613-9.372-4.013"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "9imsfgsq7df",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#vw9x16ccade"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#9imsfgsq7df)",
    d: "m154.428 90.841-9.373-4.012"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "pp6m2x4x0dh",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e6kagjunkdg"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#pp6m2x4x0dh)",
    d: "M170.922 32.085 168.52 42.13"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "8xz9lzhaodj",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cgazlwztidi"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#8xz9lzhaodj)",
    d: "m99.796 67.313-2.401 10.046"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "yibz6cf1cdl",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u9jj5i5rvdk"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#yibz6cf1cdl)",
    d: "m158.937 24.053 9.372 4.013"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "xiymhpnmadn",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#6ijzv60o0dm"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#xiymhpnmadn)",
    d: "m198.259 19.369-9.372-4.013"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "m299jq3yhdp",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#qsm73tz7xdo"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#m299jq3yhdp)",
    d: "m127.133 54.597-9.372-4.012"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "th3dkg1zzdr",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#vswpp1s7wdq"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#th3dkg1zzdr)",
    d: "m60.796 75.706-9.372-4.013"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "pfw0e25ewdt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fjwahn5ovds"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#pfw0e25ewdt)",
    d: "m183.345 75.949-2.402 10.045"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "duni7lspbdv",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#9af3y73m8du"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#duni7lspbdv)",
    d: "m112.219 111.178-2.401 10.045"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "s4sh31s1ldx",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ifdhaib38dw"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#s4sh31s1ldx)",
    d: "m144.623 38.037-2.402 10.046"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "7rw2b1tvkdz",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#2zmuemdsqdy"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#7rw2b1tvkdz)",
    d: "m198.1 31.002-10.129.929"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "a9wffogixdB",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#sj1g1a7codA"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#a9wffogixdB)",
    d: "m126.975 66.23-10.129.93"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "igbunt83odD",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#8hegrifd1dC"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#igbunt83odD)",
    d: "m174.052 69.159-6.759 7.724"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "w8hbtlvl8dF",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#yuf32rdjfdE"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#w8hbtlvl8dF)",
    d: "m102.927 104.388-6.76 7.724"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "jjo507yjmdH",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a69murlxhdG"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#jjo507yjmdH)",
    d: "m135.33 31.247-6.76 7.724"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "zz2v7tkrbdJ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n8ez3do8sdI"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#zz2v7tkrbdJ)",
    d: "m198.493 46.908-9.373-4.013"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "w5otymnlddL",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#orlro10jddK"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#w5otymnlddL)",
    d: "m127.367 82.136-9.372-4.012"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "br0bmg1whdN",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s5hecy1a0dM"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#br0bmg1whdN)",
    d: "m161.709 59.377-2.402 10.045"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "zhx5cv286dP",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#9ky4smki9dO"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#zhx5cv286dP)",
    d: "m90.583 94.606-2.401 10.045"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "wn3jlmg3odR",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pihl6vn92dQ"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#wn3jlmg3odR)",
    d: "m132.996 103.371-2.401 10.045"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "k41th5evrdT",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#wszzub1k9dS"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#k41th5evrdT)",
    d: "m204.382 49.302 8.415-5.805"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "be8575bz1dV",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#326axpiqbdU"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#be8575bz1dV)",
    d: "m133.256 84.531 8.416-5.806"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "hhihywtendX",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#uewns1z2idW"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#hhihywtendX)",
    d: "m83.851 67.731 8.416-5.806"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "nk5fomnqzdZ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#avyx4wcypdY"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#nk5fomnqzdZ)",
    d: "m163.318 53.14 9.596-3.424"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "qv47dw4iteb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iz89zbdyrea"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#qv47dw4iteb)",
    d: "m92.193 88.368 9.596-3.423"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "12uftmb36ed",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#jot00uchfec"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#12uftmb36ed)",
    d: "m205.098 24.411 8.415-5.806"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "e7yafov7hef",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#vx6phat91ee"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#e7yafov7hef)",
    d: "m133.972 59.639 8.416-5.805"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "fybuze2bgeh",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#araoojewgeg"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#fybuze2bgeh)",
    d: "m190.545 64.278 3.367 9.755"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ehl7mj5s5ej",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#2p6xpeqloei"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#ehl7mj5s5ej)",
    d: "m119.419 99.506 3.368 9.756"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "tv1hqaem1el",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#8ojdpbwp1ek"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#tv1hqaem1el)",
    d: "m151.823 26.366 3.368 9.756"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "74j2j0w01en",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#56el8fiq6em"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#74j2j0w01en)",
    d: "m219.327 41.356 9.815-2.703"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "34ruipqo3ep",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#9lw329zo2eo"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#34ruipqo3ep)",
    d: "m148.201 76.585 9.815-2.704"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "qsnk9y0tber",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#q4gna95npeq"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#qsnk9y0tber)",
    d: "m107.365 80.882 7.977-6.414"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b8an4c1rcet",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#6xsirquu2es"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#b8an4c1rcet)",
    d: "m105.187 62.598 7.977-6.414"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "7i11xc6v3ev",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fpt5vgxjreu"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#7i11xc6v3ev)",
    d: "m198.672 60.864 9.815-2.703"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "vjhv90muaex",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#itxy55j4oew"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#vjhv90muaex)",
    d: "m127.546 96.093 9.815-2.704"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "txr97ux77ez",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#2k92jgt2key"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#txr97ux77ez)",
    d: "m150.78 50.929 7.977-6.414"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "vt9f8rjfkeB",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#v9vjce7tyeA"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#vt9f8rjfkeB)",
    d: "m79.654 86.158 7.977-6.414"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "9gvwdytwoeD",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#5m1750pi0eC"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#9gvwdytwoeD)",
    d: "m185.818 18.802-9.815 2.703"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "2qwjihlf0eF",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#wcfslfidkeE"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#2qwjihlf0eF)",
    d: "m202.787 39.627 3.947-9.528"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "21hfbmxndeH",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kfakvmpcxeG"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#21hfbmxndeH)",
    d: "m131.662 74.856 3.947-9.529"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "g7titqb5keJ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ekuje5tvqeI"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#g7titqb5keJ)",
    d: "m98.835 60.538 3.947-9.528"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "21srggtxmeL",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lawd3mm4keK"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#21srggtxmeL)",
    d: "m114.713 46.221 3.947-9.528"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "7c4ywfao4eN",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#854czl40xeM"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#7c4ywfao4eN)",
    d: "m202.843 68.494 9.88 2.442"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "jlxjhxo42eP",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nuoga8c16eO"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#jlxjhxo42eP)",
    d: "m98.895 95.427 9.88 2.441"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "r0lniuyl2eR",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g30207u47eQ"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#r0lniuyl2eR)",
    d: "m216.968 32.36 3.947-9.528"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "3lrkbkumdeT",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#x2vm7kre7eS"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#3lrkbkumdeT)",
    d: "m145.843 67.589 3.947-9.529"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "h1hmsh8n9eV",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aucnc53kceU"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#h1hmsh8n9eV)",
    d: "m190.343 49.129-2.401 10.045"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "6r9tnrp1ueX",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#12u97pzc8eW"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#6r9tnrp1ueX)",
    d: "m119.217 84.358-2.401 10.045"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ccy4oygxueZ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#wlyckbzwleY"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#ccy4oygxueZ)",
    d: "m163.963 80.901-2.402 10.045"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "cn6cn7bhpfb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k06a5c026fa"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#cn6cn7bhpfb)",
    d: "m95.569 122.22-9.372-4.013"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "p45ur8td6fd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hqyoiucfufc"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#p45ur8td6fd)",
    d: "m24.444 157.449-9.373-4.013"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "r6sjioyoiff",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i4jfp1m2sfe"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#r6sjioyoiff)",
    d: "m40.938 98.692-2.402 10.045"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "k5btv8rs4fh",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dsdfsgyl9fg"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#k5btv8rs4fh)",
    d: "m-30.188 133.92-2.401 10.046"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "iv4wone0lfj",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tm5r33btzfi"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#iv4wone0lfj)",
    d: "m28.953 90.66 9.372 4.013"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ojvx1z2ynfl",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f5taoiop0fk"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#ojvx1z2ynfl)",
    d: "m68.275 85.976-9.373-4.013"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "7ccsf26dgfn",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ljdrgxs3ufm"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#7ccsf26dgfn)",
    d: "m-2.851 121.205-9.372-4.013"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "apj1vvwtyfp",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rjhrs45c1fo"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#apj1vvwtyfp)",
    d: "m53.361 142.556-2.402 10.046"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "1a183v8k4fr",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#blgylou41fq"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#1a183v8k4fr)",
    d: "m-17.765 177.785-2.401 10.045"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "m0ba2llx9ft",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#7l9740rv7fs"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#m0ba2llx9ft)",
    d: "m14.639 104.645-2.402 10.045"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "gvetd3avbfv",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m5d9s00nhfu"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#gvetd3avbfv)",
    d: "m-3.009 132.837-10.129.93"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "3r01o1bocfx",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ro1wlfkyrfw"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#3r01o1bocfx)",
    d: "m44.068 135.766-6.759 7.724"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "m7srtaueofz",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#3he4ufcvrfy"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#m7srtaueofz)",
    d: "m-27.057 170.995-6.76 7.724"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "hvj1x9ufifB",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nsrzt6inofA"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#hvj1x9ufifB)",
    d: "m5.346 97.854-6.76 7.725"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "nv93kf3s9fD",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#1kdkdoum7fC"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#nv93kf3s9fD)",
    d: "m68.509 113.515-9.373-4.013"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "wbe4gbwi0fF",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#8wdtfqwp5fE"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#wbe4gbwi0fF)",
    d: "m-2.617 148.743-9.372-4.012"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "8amgawh86fH",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#53cgsup5gfG"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#8amgawh86fH)",
    d: "m31.725 125.985-2.402 10.045"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "v7py48fjdfJ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b9hu6owqsfI"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#v7py48fjdfJ)",
    d: "m-39.401 161.213-2.401 10.046"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "peadcmectfL",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#wbrbdp53ufK"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#peadcmectfL)",
    d: "M3.013 169.978.611 180.023"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f864edmaofN",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#9xe9muz33fM"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#f864edmaofN)",
    d: "m74.397 115.909 8.416-5.805"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "kco0j4iblfP",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#5d21lucfjfO"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#kco0j4iblfP)",
    d: "m3.272 151.138 8.416-5.806"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "z0fkmjwnxfR",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hjcrfd263fQ"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#z0fkmjwnxfR)",
    d: "m-46.132 134.338 8.415-5.805"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "0zr4y351dfT",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ksl7ga83efS"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#0zr4y351dfT)",
    d: "m33.334 119.747 9.597-3.423"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "046i7mstwfV",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nl6b2gmewfU"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#046i7mstwfV)",
    d: "m9.858 168.509 9.596-3.424"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "r08ez1vhhfX",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#wnpitulexfW"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#r08ez1vhhfX)",
    d: "m-37.791 154.976 9.596-3.424"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "78ub93g8vfZ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#6nfd6kzk5fY"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#78ub93g8vfZ)",
    d: "m3.988 126.246 8.416-5.805"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "sr93ic7brgb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#qsnh6pbc4ga"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#sr93ic7brgb)",
    d: "m60.561 130.885 3.368 9.755"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "0faxb8s3qgd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h4am2bisigc"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#0faxb8s3qgd)",
    d: "m-10.564 166.113 3.367 9.756"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "hszo4rpdcgf",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m9kq2bxh8ge"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#hszo4rpdcgf)",
    d: "m21.839 92.973 3.368 9.756"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "og99r5nb4gh",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lvt6glysogg"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#og99r5nb4gh)",
    d: "m18.217 143.192 9.815-2.703"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "287v0xxbtgj",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gkhuyuruggi"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#287v0xxbtgj)",
    d: "m46.559 109.422 7.977-6.413"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "8nqn4a89bgl",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#0355389kggk"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#8nqn4a89bgl)",
    d: "m-22.619 147.489 7.977-6.414"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "6ycc482dxgn",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#whw4mvj3fgm"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#6ycc482dxgn)",
    d: "m-24.797 129.205 7.977-6.414"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "dq1x0bv40gp",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hvfxo5cz4go"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#dq1x0bv40gp)",
    d: "m-2.438 162.7 9.816-2.703"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "gg41s5znogr",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#airzja64kgq"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#gg41s5znogr)",
    d: "m20.796 117.536 7.977-6.413"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "e1iry88yvgt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#0oo5iapddgs"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#e1iry88yvgt)",
    d: "m67.702 75.929 7.977-6.413"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "dmtxuz1wkgv",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#zq28lcrthgu"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#dmtxuz1wkgv)",
    d: "m-50.33 152.765 7.977-6.414"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "s8caajz7xgx",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#sorh31017gw"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#s8caajz7xgx)",
    d: "m55.834 85.409-9.815 2.703"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "tx3swoq6xgz",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#919lpdw62gy"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#tx3swoq6xgz)",
    d: "m72.803 106.234 3.947-9.528"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "lk67wm0algB",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k553s5j2mgA"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#lk67wm0algB)",
    d: "m1.678 141.463 3.947-9.529"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "gw8r6k3cqgD",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lwusei3pbgC"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#gw8r6k3cqgD)",
    d: "m-31.15 127.145 3.947-9.528"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "jjf93sewcgF",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ix175xt0lgE"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#jjf93sewcgF)",
    d: "m40.036 126.805 9.881 2.442"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "31ws8ga02gH",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hv7jaco02gG"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#31ws8ga02gH)",
    d: "m72.859 135.101 9.881 2.442"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "wn1tihja3gJ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gobwxxxc1gI"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#wn1tihja3gJ)",
    d: "m-31.09 162.034 9.881 2.441"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "t96uhepj0gL",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#8vxyzw8ufgK"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#t96uhepj0gL)",
    d: "m15.859 134.196 3.947-9.528"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "4v7b6r0ujgN",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#icfz9wd8tgM"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#4v7b6r0ujgN)",
    d: "m60.359 115.736-2.401 10.045"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "48wt2rg2tgP",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#y92cve781gO"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#48wt2rg2tgP)",
    d: "m-10.767 150.965-2.401 10.045"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.848 115.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ahmn1w9j8gR",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#3w9e7risygQ"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAE2BC",
    strokeWidth: 0.941,
    mask: "url(#ahmn1w9j8gR)",
    d: "m33.978 147.508-2.401 10.046"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M418.67 306.814c.084 1.96.306 3.36.663 4.2.435 1.02 1.24 2.44 2.416 4.254 1.189-.501 11.87-5.021 32.046-13.56-1.217-2.91-2.22-4.154-4.11-3.614-1.887.54-2.688.753-3.95 1.08l-17.712-.318a.616.616 0 0 0-.628.605v.016l.029 2.721c-1.333 1.476-2.517 2.433-3.557 2.872-.844.357-2.153.51-3.928.46a1.23 1.23 0 0 0-1.27 1.196v.088z",
    fill: "#22244E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.35 94.658 8.806 5.434c-19.607 17.45-30.05 26.646-31.327 27.588-2.876 2.124-3.1 7.896-3.486 10.835-4.287-.555-.512-5.894-5.966-6.52-4.98-.57-9.928.887-12.713-4.602-.342-.675-.16-2.318 1.908-2.423 5.156-.264 13.057-1.41 14.642-2.409 2.162-1.36 11.542-10.662 28.137-27.903M309.123 33.352s-5.204 3.71-6.27 13.271c-1.41.018-2.525-5.022-2.525-5.022l3.24-10.038 3.298-2.942 2.257 4.73z",
    fill: "#FE912A"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(230.891)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "wsy53bfasgT",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#yr7sv9uf4gS"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.862 17.127s5.037-4.98 14.286-2.667c0 0 4.24-4.765-2.335-8.802C81.24 1.619 76.38.408 67.931 5.08c-6.908 3.82-11.26 3.082-16.578.677-5.318-2.403-8.073-5.234-12.47-4.197-4.398 1.038-7.14 5.177-11.889 3.387C22.246 3.157 20.25-1.9 11.917.753 3.584 3.407-6.717 16.56 5.899 29.83c12.615 13.267 31.487 10.267 42.94 7.96 11.453-2.307 22.194-4.964 23.593-8.777 1.399-3.814-2.18-8.09 3.43-11.885",
    fill: "#9C3A83",
    mask: "url(#wsy53bfasgT)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M183.046 63.191c13.826-7.836 30.581-10.508 48.868-14.32l-11.803 7.042-29.175 9.697s-7.855-.362-7.89-2.419",
    fill: "#007371"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.706 18.532c0 1.962-1.134 3.552-2.532 3.552-1.399 0-2.533-1.59-2.533-3.552 0-1.96 1.134-3.55 2.533-3.55 1.398 0 2.532 1.59 2.532 3.55M321.006 24.331l.642 6.596a.64.64 0 0 1-.844.668l-3.667-1.243 3.869-6.021z",
    fill: "#FE912A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m226.927 101.904 3.964.447s-34.667 36.419-42.683 34.01c-8.015-2.409-41.074-40.608-38.584-48.957 2.488-8.346 36.988-26.104 36.988-26.104l40.315 40.604z",
    fill: "#007371"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.516 124.392a4.311 4.311 0 0 1 .224-4.11l1.512-2.459a4.348 4.348 0 0 1 4.802-1.926 73.308 73.308 0 0 0 2.356-3.694c6.227-10.467 7.464-22.642 11.862-33.35-19.28 6.608-40.595 22.715-63.95 48.326l-14.985-11.627a330.475 330.475 0 0 1 4.814-6.307c-1.518-1.876-1.798-7.851.183-8.054a21.306 21.306 0 0 1 6.128.259c33.976-40.556 72.869-64.7 116.683-72.432l4.847 1.903 4.96 3.77c-18.655 38.43-25.644 114.028-72.48 178.12-12.796-2-22.344-12.262-36.715-20.137-18.176-9.96-25.307-32.296-49.23-32.182 13.13-29.202 55.879-9.079 78.99-36.1",
    fill: "#AAE2BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.675 109.613a3.861 3.861 0 0 0-4.354 2.36 3.84 3.84 0 0 0 2.175 4.987 3.861 3.861 0 0 0 5.004-2.168 3.843 3.843 0 0 0-2.825-5.18M253.07 130.628a3.862 3.862 0 0 0-4.354 2.36 3.841 3.841 0 0 0 2.824 5.18 3.863 3.863 0 0 0 4.355-2.36 3.842 3.842 0 0 0-2.177-4.988 4.014 4.014 0 0 0-.648-.192M244.954 152.876a3.86 3.86 0 0 0-4.354 2.36 3.84 3.84 0 0 0 2.175 4.987 3.864 3.864 0 0 0 5.004-2.168 3.841 3.841 0 0 0-2.176-4.986 3.755 3.755 0 0 0-.65-.193",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.73 29.018s-4.643 28.135-20.186 46.158c-14.468 16.78-40.386 26.138-40.386 26.138l4.444 3.905s20.098-3.601 43.01-30.661c16.84-19.886 19.43-45.659 19.43-45.659l-6.312.119z",
    fill: "#007371"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m432.033 310.395 6.45 4.152 16.267-7.156v-.002l-2.936-5.496-19.781 8.502zm-1.149.492v.001l1.149-.493h-.002l-1.147.492zm-8.616 3.704 3.576 5.454 8.432-3.745-3.392-5.412-8.616 3.703z",
    fill: "#007371"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m319.152 24.827-1.574-.882a2.62 2.62 0 0 1-1.005-3.598l1.029-1.786a.825.825 0 0 1 1.116-.304l3.189 1.787a.094.094 0 0 1 .036.128l-2.66 4.619a.096.096 0 0 1-.13.036",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FEFEFE",
    strokeWidth: 0.903,
    strokeLinecap: "round",
    d: "m319.089 19.107-11.464-2.866"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007371",
    d: "m71.652 211.134-5.638 36.304-5.826-1.474 2.696-20.416 7.064-3.447.2-1.29-6.483.041 1.369-9.534z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M393.36 135.405s5.085 8.854-5.656 8.854l5.655-8.854z",
    fill: "#FE912A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.11 113.7c-.946-4.232-.547-7.836.042-12.082.443-3.196.63-7.719-3.388-7.983-3.355-.22-5.459 3.193-5.567 6.598-.338 10.591 8.913 13.468 8.913 13.468",
    fill: "#FEC988"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M531.179 292.339h28.661V321h-28.661z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationRunningHero);
export default __webpack_public_path__ + "static/media/illustration-running-hero.f76cc596117186e1898b9c14112310e1.svg";
export { ForwardRef as ReactComponent };